// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9250aa2f","455":"01c7e407"}[chunkId] + ".chunk.js";
};